import { useState, useEffect } from 'react';

const GUEST_NAME_KEY = 'ichrahly-meet-guest-name';

/**
 * A custom hook to manage a guest's name in local storage for persistence.
 */
export const useGuestName = () => {
    const [guestName, setGuestName] = useState(() => {
        try {
            const item = window.localStorage.getItem(GUEST_NAME_KEY);
            return item ? JSON.parse(item) : '';
        } catch (error) {
            console.error("Error reading guest name from local storage", error);
            return '';
        }
    });

    useEffect(() => {
        try {
            window.localStorage.setItem(GUEST_NAME_KEY, JSON.stringify(guestName));
        } catch (error) {
            console.error("Error saving guest name to local storage", error);
        }
    }, [guestName]);

    return [guestName, setGuestName];
};
